//省市县的 JS 文件
import shengShixian from './shengshixian'
//根据银行卡匹配银行名称
import getBKNameByCardNo from './banksReg'
//引入状态
import store from '../store'
//引入路由
import $router from '../router' 
//vue
import vue from 'vue'
//公用模态框 关闭事件
let obj = {
	/*
	 * func:根据银行卡号获得银行名称
	 */
	getBKNameByCardNo:(cardNo)=>{
		return getBKNameByCardNo(cardNo);
	},
	/*
	 * 获得所有的省市县
	 * */
	getShengShiXian:(res) =>{ return shengShixian; },
	/*
	 * 获得所有 协议的基础地址
	 * */
    getAgreementUrl:(res) =>{ return 'https://newtrade.tkfunds.com.cn/tkapp-web/'; }, ////'http://10.92.1.120/tkapp-web/''https://newtrade.tkfunds.com.cn/tkapp-web-pre/'
    /*
	 * 获取免责协议的基础地址
	 * */
    getAgreementUrlNew:(res) =>{ return 'https://newtrade.tkfunds.com.cn/tkfile/'; },
    /*
	 * 设置页面的滚动
	 * */
    setScroll:(num) => {  
        let timer = null, appScroll = 0, winScroll = 0;
        appScroll = $('#app').scrollTop();
        winScroll = $(window).scrollTop();
        //设置 滚动置顶的动画
        timer = setInterval(function() {
            if(winScroll - 130 > 0) {
                winScroll = winScroll - 130;
                $(window).scrollTop(winScroll)
            } else {
                clearInterval(timer);
                timer = null;
                $(window).scrollTop(0)
            }
        }, 0);
    },
    /**
	 * 格式化日期 将不带-的日期加-
	 **/
    formatDate : function(str){
        let yaer = str.substring(0,4),
            month = str.substring(4,6),
            day = str.substring(6,8);
        return yaer + '-' + month + '-' + day;
    },
    //阿拉伯数字转换为大写汉字
    Arabia_To_Chinese:(n)=>{
        var unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
        n += "00";  
        var a = n.indexOf('-');
        if(a != -1){
            n = n.substring(1);
            var indexpoint = n.indexOf('.');  // 如果是小数，截取小数点前面的位数
            if (indexpoint >= 0){
                n = n.substring(0, indexpoint) + n.substr(indexpoint+1, 2);   // 若为小数，截取需要使用的unit单位
            }		    
            unit = unit.substr(unit.length - n.length);  // 若为整数，截取需要使用的unit单位
            for (var i=0; i < n.length; i++){
                str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);  //遍历转化为大写的数字
            }
            return "负数"+str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万/g, "$1").replace(/^元零?|零分/g, "").replace(/元$/g, "元整").replace(/角$/g, "角整"); // 替换掉数字里面的零字符，得到结果
        }else{
            var indexpoint = n.indexOf('.');  // 如果是小数，截取小数点前面的位数
            if (indexpoint >= 0){
                n = n.substring(0, indexpoint) + n.substr(indexpoint+1, 2);   // 若为小数，截取需要使用的unit单位
            }	    
            unit = unit.substr(unit.length - n.length);  // 若为整数，截取需要使用的unit单位
            for (var i=0; i < n.length; i++){
                str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);  //遍历转化为大写的数字
            }
            return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万/g, "$1").replace(/^元零?|零分/g, "").replace(/元$/g, "元整").replace(/角$/g, "角整"); // 替换掉数字里面的零字符，得到结果
        }
    },
	/*
	 * 显示错误提示信息
	 * elem:检验有误的元素
	 * strMsg:错误提示信息
	 * */
	showErrorMsg:function(elem,strMsg){
		//清除现有的错误提示信息
		elem.siblings('span.errorMsg').css('display','none').removeClass('shake').removeClass('lightSpeedOut').children('span').remove();
		//显示当前的错误提示信息
		elem.addClass('input_error').siblings('span.errorMsg').append("<span>"+strMsg+"</span>")
			.css('display','inline-block').addClass('shake');
		//获得焦点时，隐藏错误信息
		elem.focus(function(){ 
			$(this).removeClass('input_error').siblings('span.errorMsg').removeClass('shake').addClass('lightSpeedOut')
		});
	},
	/*
	 * 分页框 初始化
	 * elem_box:分页的容器
	 * total： 总记录数
	 * pageSize：每页显示 条数  默认是 8条
	 * pageOnFn：页面点击事件
	 * jumpOnFn：跳转点击事件
	 * searchOnFn：跳转时触发的事件
	 * */
	initPage:(total,pageOnFn,jumpOnFn,searchOnFn)=>{
		let pageSize = 20 , elem_box = '.paging';
		let totalPage =  parseInt(total)/pageSize;//总页数
		if(parseInt(total)%pageSize != 0){
			totalPage = parseInt(totalPage) + 1;
		}
		//初始化 分页框
		$(elem_box).Page({
			Page:1,    //默认当前选中的页数
			Pages:totalPage, //总页数
			PageNum:5, //显示的页码个数
			ActiveClass: "paging-selecte",//选中的样式
			Search:true, // 是否跳转功能 true未开启 false为关闭 默认开启 
		    TopDownpage:true, // 是否开启上一页 下一页功能 true未开启 false为关闭 默认开启 
			PageOn: function(pNum) { //页码点击事件
				pageOnFn(pNum);
				//显示的条数范围
				let minNum = (pNum-1)*pageSize + 1, maxMin = pNum*pageSize;				
				if(total < maxMin){
					maxMin = total;
				}
				//在分页框最后增加 总页数
				$('.paging').prepend("<p>共 "+totalPage+" 页，显示 " + minNum + " - "+ maxMin +" 条</p>");
			},
			JumpOn: function(pNum) { //跳转按钮点击事件
				jumpOnFn(pNum);
				//显示的条数范围
				let minNum = (pNum-1)*pageSize + 1, maxMin = pNum*pageSize;
				if(total < maxMin){
					maxMin = total;
				}
				//在分页框最后增加 总页数
				$('.paging').prepend("<p>共 "+totalPage+" 页，显示 " + minNum + " - "+ maxMin +" 条</p>");
			},
			SearchOn:function(pNum){ //点击跳转时触发事件
				//searchOnFn(pNum)
			}, 
		},true);
		//在分页框最后增加 总页数
		$('.paging').prepend("<p>共 "+totalPage+" 页，显示 1 - "+ pageSize +" 条</p>");
	},
	/*
	 * 获得当前的用户名称
	 * */
	getUserName(cName) {
		let obj =  getCookie(cName);
		if(cName == 'UINFO'){
			return JSON.parse(obj).user_nick;
		}else{
			return obj;
		}
	},
	/*
	 * 关闭错误提示框
	 * */
	hideErrorMsg_model: () => {
		$('#errorMsgBox').fadeOut().css('display','none').find('#errorMsgTip').html('');
	},
	/*
	 * 显示错误提示信息
	 * msg:提示信息
	 * strTitle:标题头
	 * btnTxt:按钮地址
	 * strUrl:跳转地址
	 * */
	showErrorMsg_model: (msg,strUrl,strTitle,btnTxt,isShowCancle) => {
		let errorModel = $('#errorMsgBox').fadeIn();  	
		errorModel.find('#errorMsgTip').html(msg); //提示信息
		if(msg.length > 50){
			// errorModel.find('.model-box').width('26rem');
			errorModel.find('#errorMsgTip').removeClass('txt-center').addClass('txt-left');
			// errorModel.find('#errorMsgTip').removeClass('ft-size-16').addClass('ft-size-14');
		}else{
			errorModel.find('.model-box').width('18.5rem');
			errorModel.find('#errorMsgTip').removeClass('txt-left').addClass('txt-center');
			errorModel.find('#errorMsgTip').removeClass('ft-size-14').addClass('ft-size-16');
		}
		errorModel.find('#errorUrl').val(strUrl); //提示信息
		if(strTitle!=''){
			errorModel.find('.mdl-title').html(strTitle); //标题头
        }
        //不显示关闭按钮
        if(strTitle == '非法操作提示' || !isShowCancle){
            $('#errorMsgBox .model-title span:last-child').hide();
        }else{
            $('#errorMsgBox .model-title span:last-child').show();
        }
		if(btnTxt!=''){
			errorModel.find('button').html(btnTxt); //按钮信息
		}
	},
	/*
	 * 关闭 Confirm 提示框
	 * */
	hideConfirmMsg_model: () => {
		$('#confirmMsgBox').fadeOut().css('display','none').find('#confirmMsgTip').html('');
	},
	/*
	 * 显示 Confirm 提示弹框
	 * okUrl:确定跳转的地址
	 * ccUrl：取消确定的地址
	 * */
	showConfirmMsg_model: (msg,okUrl,ccUrl,okTxt,ccTxt,strTitle) => {
		let errorModel = $('#confirmMsgBox').fadeIn();  	
		errorModel.find('#confirmMsgTip').html(msg);
		//字数较多则左对齐
		if(msg.length > 50){
			// errorModel.find('.model-box').width('26rem');
			errorModel.find('#confirmMsgTip').removeClass('txt-center').addClass('txt-left');
			// errorModel.find('#confirmMsgTip').removeClass('ft-size-16').addClass('ft-size-14');
		}else{
			errorModel.find('.model-box').width('18rem');
			errorModel.find('#confirmMsgTip').removeClass('txt-left').addClass('txt-center');
			errorModel.find('#confirmMsgTip').removeClass('ft-size-14').addClass('ft-size-16');
		}
		errorModel.find('#confirmOkUrl').val(okUrl);
		errorModel.find('#confirmCCUrl').val(ccUrl);
		if(strTitle != ''){
			errorModel.find('.mdl-title').html(strTitle);
		}
		if(okTxt != ''){
			errorModel.find('.okBtn').html(okTxt);
		}
		if(ccTxt != ''){
			errorModel.find('.ccBtn').html(ccTxt);
		}
	},
	//组合下拉框的 js调用
	dorpDownFn:()=>{	 
		$('.dropDown-box').on('click','.dropDown-title',function(){  
			if($(this).next('.dropDown-item').css('display') == 'flex'){
				$(this).next('.dropDown-item').css('display','none');
				$(this).find('.fa-angle-down').css('transform','rotateZ(0deg)');
			}else{
				//首先关闭所有的 组合下拉框
				$('.dropDown-box .dropDown-item').css('display','none');
				$('.dropDown-box').find('.fa-angle-down').css('transform','rotateZ(0deg)');
				//展现当前的
				$(this).next('.dropDown-item').css('display','flex');
				$(this).find('.fa-angle-down').css('transform','rotateZ(-180deg)');
			}
		})
		$('.dropDown-box').on('click','.dropDown-item>li',function(){
			$(this).parent().css('display','none');
			$(this).parent().parent().find('.fa-angle-down').css('transform','rotateZ(0deg)');
		})
	},
	/*
	 * 排序  -- 降序
	 * arr：需要排序的数组
	 * col：需要排序的列
	 * */
	orderByDesc:(orderArr,col) => {
		for(var i=0; i<orderArr.length;i++){
		    for(var j=i+1;j<orderArr.length;j++){
                let orderArr_i = parseFloat(orderArr[i][col]),orderArr_j =  parseFloat(orderArr[j][col]);
                if(isNaN(orderArr_i)){
                    orderArr_i = 0;
                }else if(isNaN(orderArr_j)){
                    orderArr_j = 0;
                }
                if(orderArr_i < orderArr_j){
		         	let tmp=orderArr[i];
		            orderArr[i]=orderArr[j];
                    orderArr[j]=tmp;
		        }
		     }
		}
		return orderArr;
	},
	/*
	 * 排序  -- 升序
	 * */
	orderByAsc:(orderArr,col) => {
		for(var i=0; i<orderArr.length;i++){
		    for(var j=i+1;j<orderArr.length;j++){
                let orderArr_i = parseFloat(orderArr[i][col]),orderArr_j =  parseFloat(orderArr[j][col]);
                if(isNaN(orderArr_i)){
                    orderArr_i = 0;
                }else if(isNaN(orderArr_j)){
                    orderArr_j = 0;
                }
                 if(orderArr_i > orderArr_j){
		         	let tmp=orderArr[i];
		            orderArr[i]=orderArr[j];
		            orderArr[j]=tmp;
		        }
		     }
		}
		return orderArr;
	},
	/*
	 * 认申购、定投时的金额输入时的校验
	 * */
	shareValid:(newVal,oldVal) => {
        if(newVal){
            newVal = newVal.replace(/^\s+|\s+$/g,'');
        }
        if(oldVal){
            oldVal = oldVal.replace(/^\s+|\s+$/g,'');
        }
		let str = newVal.split('.') , retVal = newVal;
		if(parseFloat(newVal) > 2000000000){
			retVal = oldVal; //最大值不能超过20亿
		}else if(str.length > 1 && str[1].length>2){
			retVal = oldVal; //小数点后保留两位
		}else if(isNaN(newVal) || parseFloat(newVal) < 0){
			retVal = oldVal; //必须是数字 或 大于零
		}
		return retVal;
	},
	//获得只有 登陆后才能访问的 路由
	getLoginedRouter:()=>{
		let routerList = [
            '/myaccount','/myaccount/info','/myaccount/inTheWay',
            '/fundsList','/fundPurchases','/fundPurchases/success','/fundPurchases/success/remits','/fundPurchases/fail',
            '/fundsDate','/fundsDate/buyNew','/fundsDate/buy','/fundsDate/buy/success','/fundsDate/buy/fail',
            '/fundsDate/edit','/fundsDate/edit/success','/fundsDate/edit/fail',
            '/fundRedeem','/fundRedeem/success','/fundRedeem/fail',
            '/fundTransform','/fundTransform/success','/fundTransform/fail',
            '/accountQuery','/myselection','/myappointment','/appointment/redeemNew','/appointment/redeem',
            '/appointment/transformNew','/appointment/transform','/appointment/buyNew','/appointment/result',
            '/bankCards','/bankCard/trades','/bankCard/add','/bankCard/update','/bankCard/result',
            '/mymessage','/myintegral',
            '/fengxianceping','/fengxiancepingjieguo','/accountmanagement','/myaccountpasswordedit',
            '/myaccountphoneedit','/myaccount_zjzh','/myaccount_zjzh_set','/myaccount_zjzhfail',
            '/myaccount_zjzhsuccess','/myaccount_zjzhphonefail',
			'/myaccount_zjzhphonesuccess','/w_passedit','myaccount/assetProof','myaccount/assetProofInfo',
            'myaccount/assetProofList','myaccount/assetProofResult',
            '/redeemBuyNew','/redeemBuy','/redeemBuyResult','/redeemBuyList'
		];
		return routerList;
	},
	//获得只有 开户用户才能访问的 路由
	getOpenUserRouter:()=>{
		let routerList = [
			'/myaccount','/myaccount/info','/myaccount/inTheWay','/fundPurchases','/fundPurchases/success',
			'/fundPurchases/success/remits','/fundPurchases/fail','/fundsDate','/fundsDate/buyNew',
			'/fundsDate/buy','/undsDate/buy/success','/fundsDate/buy/fail','/fundsDate/edit',
			'/fundsDate/edit/success','/fundsDate/edit/fail','/fundRedeem','/fundRedeem/success',
			'/fundRedeem/fail','/fundTransform','/fundTransform/success','/fundTransform/fail','/accountQuery',
			'/myappointment','/appointment/redeemNew','/appointment/redeem','/appointment/transformNew',
			'/appointment/transform','/appointment/buyNew','/appointment/result','/bankCards','/bankCard/trades',
			'/bankCard/add','/bankCard/update','/bankCard/result','/fengxianceping','/fengxiancepingjieguo',
			'/myaccountpasswordedit','/myaccountphoneedit','/myaccount_zjzh','/myaccount_zjzh_set',
			'/myaccount_zjzhfail','/myaccount_zjzhsuccess','/myaccount_zjzhphonefail',
			'/myaccount_zjzhphonesuccess','/w_passedit','myaccount/assetProof','myaccount/assetProofInfo',
            'myaccount/assetProofList','myaccount/assetProofResult',
            '/redeemBuyNew','/redeemBuy','/redeemBuyResult','/redeemBuyList'
		];
		return routerList;
	},
	//检测路由（在 main js 配置）
	watchRouter:(currRouter,router,fromPath)=>{
		let isNextRouter = true; //是否可跳转下一个路由
		let routerListLogin = obj.getLoginedRouter(); //获得只有 登录 才可访问的路由
        let routerListOpen = obj.getOpenUserRouter(); //获得只有 开户 才可访问的路由
		//如果没有登录, 直接跳转至登录页
		if(!store.state.userInfo.token){ 
            //遍历 所有登录才可访问的页面
            for(let t in routerListLogin){
                let tmpRouter = routerListLogin[t].toLowerCase();
                //console.log('tmpRouter',tmpRouter,'-----------','currRouter',currRouter)
				if(tmpRouter == currRouter){
					router.push({path:'/login'}); 
					isNextRouter = false;
					break;
				}				
            }
		}else if(store.state.userInfo.userType < 2){ //如果只注册没有的开户
            //遍历 只有注册才能访问的页面
            for(let t in routerListOpen){
				let tmpRouter = '/' + routerListOpen[t].toLowerCase();
				if(tmpRouter == currRouter){
					obj.showConfirmMsg_model('该操作需开设基金账户，您尚未开户<br>是否立即前往?','/register/bank',fromPath); 
					isNextRouter = false;
					break;
				}				
			}
		}
		return isNextRouter;
    },
    //检测路由是否可以跳转
    watchPouterIsPass:(routerPath,router)=>{         
        //主要是不按步骤访问页 或 是直接访问结果页
        //判断当前 页 是不是 可以访问将要访问的页面

        // 所有可通过路由的 数组 及 依赖 前路由
        // 想要访问 pathName ,必须从 relyOn 跳转
        // 否则不让访问,跳转至首页
        let routerPassList = {
            //注册开户相关************************
            register:[
                {
                    pathName:'/register/setPwd', //-- 注册 设置密码
                    relyOn:'/register/phone'   
                }, 
                {
                    pathName:'/register/phone/success', //-- 注册 成功
                    relyOn:'/register/setPwd'   
                }, 
                {
                    pathName:'/register/phone/fail', //-- 注册 失败
                    relyOn:'/register/setPwd'   
                }, 
                {
                    pathName:'/register/bank', //-- 实名绑定 -- 注册成功后开始开户
                    relyOn:'/register/success,/register/info,/myaccount,/fundslist,/register/phone/result,/accountmanagement,/myselection'   
                }, 
                {
                    pathName:'/register/info', //-- 信息填写  
                    relyOn:'/register/bank,/register/risk'   
                }, 
                {
                    pathName:'/register/resetPwdCheck', //-- 密码校验
                    relyOn:'/register/info'   
                }, 
                {
                    pathName:'/register/resetPwd', //-- 重置密码
                    relyOn:'/register/resetPwdCheck'   
                }, 
                {
                    pathName:'/register/risk', //-- 风险评测
                    relyOn:'/register/resetPwdCheck,/register/resetPwd'   
                }, 
                {
                    pathName:'/register/riskResult', //-- 风险评测 结果
                    relyOn:'/register/risk'   
                }, 
                {
                    pathName:'/register/success', //-- 注册成功
                    relyOn:'/register/riskResult'   
                }, 
                {
                    pathName:'/register/fail', //-- 注册失败
                    relyOn:'/register/resetPwd,/register/resetPwdCheck,/register/riskResult'   
                }, 
            ],
            //密码找回相关************************
            forgetPwd:[
                {
                    pathName:'/forgetpwd/phone', //-- 验证手机号
                    relyOn:'/forgetpwd/select'   
                },
                {
                    pathName:'/forgetpwd/info', //-- 验证信息
                    relyOn:'/forgetpwd/phone,/forgetpwd/select'   
                },
                {
                    pathName:'/forgetpwd/setPwd', //-- 设置密码
                    relyOn:'/forgetpwd/phone,/forgetpwd/info,/forgetpwd/bank'      
                },
                {
                    pathName:'/forgetpwd/bank', //-- 验证银行卡
                    relyOn:'/forgetpwd/info,/forgetpwd/phone'   
                },
                {
                    pathName:'/forgetpwd/result', //-- 密码找回结果
                    relyOn:'/forgetpwd/setPwd'   
                }
            ],
            //基金申购相关************************
            buyFund:[
                {
                    pathName:'/fundPurchases', //-- 基金申购
                    relyOn:'/fundslist,/myaccount,/myaccount/info,/fundPurchases/fail,/myselection'   
                },
                {
                    pathName:'/fundPurchases/success', //-- 申购成功
                    relyOn:'/fundPurchases'   
                },
                {
                    pathName:'/fundPurchases/fail', //-- 申购失败
                    relyOn:'/fundPurchases'   
                },
                {
                    pathName:'/fundPurchases/success/remits', //-- 汇款下单成功
                    relyOn:'/fundPurchases'   
                }
            ],
            //基金定投相关************************
            fixedFund:[
                {
                    pathName:'/fundsDate/buy', //-- 基金定投
                    relyOn:'/fundsList,/myselection'   
                },
                {
                    pathName:'/fundsDate/buyNew', //-- 新增基金定投
                    relyOn:'/fundsDate'   
                },
                {
                    pathName:'/fundsDate/buy/result', //-- 定投结果
                    relyOn:'/fundsDate/buy,/fundsDate/buyNew'   
                },
                {
                    pathName:'/fundsDate/edit', //-- 修改定投计划
                    relyOn:'/fundsDate'   
                },
                {
                    pathName:'/fundsDate/edit/result', //-- 修改定投计划 结果
                    relyOn:'/fundsDate/edit'   
                }
            ],
            //基金 赎回,转换 相关************************
            redeemTransformFund:[
                {
                    pathName:'/fundRedeem,', //-- 基金赎回
                    relyOn:'/myaccount/info'   
                },
                {
                    pathName:'/fundRedeem/success', //-- 基金赎回 成功
                    relyOn:'/fundRedeem'   
                },
                {
                    pathName:'/fundRedeem/fail', //-- 基金赎回 失败
                    relyOn:'/fundRedeem'   
                },
                {
                    pathName:'/fundTransform', //-- 基金转换
                    relyOn:'/myaccount/info'   
                },
                {
                    pathName:'/fundTransform/result', //-- 基金转换 结果
                    relyOn:'/fundTransform'   
                },
                {
                    pathName:'/redeemBuy', //-- 基金赎回转认购
                    relyOn:'/myaccount/info'   
                },
                {
                    pathName:'/redeemBuyResult', //-- 基金赎回转认购 结果
                    relyOn:'/redeemBuy,/redeemBuyNew'   
                }
            ],
            //基金 预约 相关************************
            appointment:[ 
                {
                    pathName:'/appointment/redeem', //-- 预约赎回
                    relyOn:'/myaccount/info'   
                },
                {
                    pathName:'/appointment/redeemNew', //-- 新建预约赎回
                    relyOn:'/myappointment'   
                },
                {
                    pathName:'/appointment/transform', //-- 预约转换 
                    relyOn:'/myaccount/info'   
                },
                {
                    pathName:'/appointment/transformNew', //-- 新建预约转换 
                    relyOn:'/myappointment'   
                },
                {
                    pathName:'/appointment/buyNew', //-- 新建预约赎回转认购
                    relyOn:'/myappointment'   
                },
                {
                    pathName:'/appointment/result', //-- 预约结果
                    relyOn:'/appointment/redeem,/appointment/redeemNew,/appointment/transform,/appointment/transformNew,/appointment/buyNew'   
                },
                {
                    pathName:'/appointment/subscription', //-- 预约认购
                    relyOn:'/myappointment'   
                },
                {
                    pathName:'/appointment/subscriptionRes', //-- 预约认购
                    relyOn:'/appointment/subscription'   
                }
            ],
            //赎回转认购************************
            redeemBuy:[ 
                {
                    pathName:'/redeemBuy', //-- 赎回转认购
                    relyOn:'/redeemBuyList,/myaccount/info'   
                },
                {
                    pathName:'/redeemBuyNew', //-- 新建赎回转认购
                    relyOn:'/redeemBuyList'   
                },
                {
                    pathName:'/redeemBuyResult', //-- 赎回转认购 结果 
                    relyOn:'/redeemBuy,/redeemBuyNew'   
                },
            ],     
            //换卡相关************************
            banksInfo:[            
                {
                    pathName:'/bankCard/trades', //-- 银行卡交易记录
                    relyOn:'/bankCards'    
                },
                {
                    pathName:'/bankCard/add', //-- 添加银行卡
                    relyOn:'/bankCards'    
                },
                {
                    pathName:'/bankCard/newAdd', //-- 添加银行卡
                    relyOn:'/fundPurchases,/fundsFixed/buy,/fundsFixed/buyNew' 
                },
                {
                    pathName:'/bankCard/update', //-- 换卡
                    relyOn:'/bankCards,/bankCard/update/review/result'  
                }, 
                {
                    pathName:'/bankCard/update/result', //-- 换卡结果
                    relyOn:'/bankCard/update,/bankCards'    
                } 
            ],
            //账户信息************************
            accountInfo:[    
                {
                    pathName:'/account/phoneOld', //-- 修改绑定手机 -- 校验旧手机号
                    relyOn:'/accountmanagement,/accountmanagementEdit'    
                },        
                {
                    pathName:'/account/phoneEdit', //-- 修改绑定手机 -- 校验新手机号
                    relyOn:'/account/phoneOld'    
                },
                {
                    pathName:'/account/phoneEdit/result', //-- 修改绑定手机 成功
                    relyOn:'/account/phoneEdit'    
                },
                {
                    pathName:'/myaccount_zjzh_set', //-- 修改密码
                    relyOn:'/accountmanagement,/accountmanagementEdit,/myaccount_zjzhfail'    
                },
                {
                    pathName:'/account/accountPhoneNumaId', //--  //-- 我的--重置密码(姓名+身份证号码)
                    relyOn:'/accountmanagement,/accountmanagementEdit,/account/editPwd/result'  
                },
                {
                    pathName:'/account/accountPhoneMassage', //--  我的--重置密码(手机号及短信校验)
                    relyOn:'/account/accountPhoneNumaId'  
                },
                {
                    pathName:'/account/accountPhonePasswordRest', //-- 我的--重置密码(密码重置)
                    relyOn:'/account/accountPhoneMassage'  
                },
                {
                    pathName:'/account/editPwd/result', //-- 我的--重置密码(密码重置)
                    relyOn:'/account/editPwd,/account/accountPhonePasswordRest'  
                },
                {
                    pathName:'/account/accountPhoneSucess', //--  我的--重置密码(完成)
                    relyOn:'/account/accountPhonePasswordRest'  
                }
            ]
        }, relyOnRouter = store.state.relyOnRouter || '/noPass',toPath = '';
        //console.log('relyOnRouter',relyOnRouter)
        // 遍历所有检测
        for(let t in routerPassList){
            //遍历检测当前对象
            for(let r in routerPassList[t]){
                let tmpObj = routerPassList[t][r];
                // 没有检测到依赖的路由,则跳转至首页 或 登录页
                // console.log(1,tmpObj.pathName,tmpObj.relyOn,relyOnRouter ,tmpObj.relyOn == relyOnRouter)
                // console.log(2,routerPath,tmpObj.pathName.toLowerCase())
                // console.log(3,tmpObj.relyOn.toLowerCase().indexOf(relyOnRouter.toLowerCase()))
                if( routerPath == tmpObj.pathName.toLowerCase() && 
                    tmpObj.relyOn.toLowerCase().indexOf(relyOnRouter) < 0){
                    if(!store.state.userInfo.token){ //-- 如果没有登录
                        toPath = '/login';
                    }else if(store.state.userInfo.userType == 1){ //-- 如果是注册未开户用户
                        toPath = '/fundslist';
                    }else if(store.state.userInfo.userType == 2){ //-- 如果是开户用户
                        
                        toPath = '/myaccount';
                    } 
                    break;
                }
            }
        }
        //如果检测到了
        if(toPath != ''){ 
            if(window.location.pathname == "/fundPurchases" && window.location.search.split('=').length < 2 ){
                // 跳回 当前角色的首页 
                $router.push({path:toPath});
                // 提示非法操作 
                obj.showErrorMsg_model('您是非法操作,不能访问哦','','非法操作提示','我知道了'); 
            }
        }
    },
    // 千分位
    Separator:(num) => {
      num = String(num)
      let num1 = num.split(".")[0], num2 = num.split(".")[1];
      let c = num1.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      return num.toString().indexOf(".") !== -1 ? c + "." + num2 : c;
    },
    //RSA 加密
    encryptionRSA: (that,params) => { 
        //-- 1.初始化 RSA 对象
        let encryptorObj = new that.$jsEncrypt() , keys = '', encryptorStr = '';
        //-- 2.获得 公钥
        keys = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAIgnqeyWmfXA5H2M0iMfG55wJKsZCmVoNG1DhhLrdlKEOKXUOAJ80wYfIDojC8CAnL3RN8Y6mUWOF4DzMIkiC4ECAwEAAQ==';
        //-- 3.设置 公钥
        encryptorObj.setPublicKey(keys);  
        if(params == null){
          params = ''
        }
        //-- 4.加密 
        encryptorStr = encryptorObj.encrypt(params);
        //返回 加密后的 字符串
        return encryptorStr;
    },
    //RSA 解密
    decryptRSA: (that,params) => {
        //-- 1.初始化 RSA 对象
        let decryptObj = new that.$jsEncrypt() , keys = '' , decryptStr = '';
        //-- 2.获得 私钥
        keys = 'MIIBVQIBADANBgkqhkiG9w0BAQEFAASCAT8wggE7AgEAAkEAzM3GrF8s4l9diiPT6ty9pBguHLwALDSvb+iZ9VTWAO/jOXEcYKHQHtSvcgijOmZ2k6VZ8964wkT2I549ucZu0wIDAQABAkEAxnaSE++W+zcW2gqmDW4jh6S26rl0IWJcr8FjkE3Jo9UXAW6e8Rokwxcrms+jqqXqylfSAW2vmiGV98d8fwEdwQIhAOy+uOeUv9E34YYTxa3IMih18XSdB1Fk1CHnOBYW0Kr5AiEA3XYBOuiUPQ4VPJy6kohWC/l6UNlE8hzDRToixY+GLysCID9Cl1YKQVc+f1y8W84b+IsnOOXYL+Rn9Oc6SZpdblTBAiBrLWH5BXhAeCFU/TDaG7sw/mLw38WbOspSJYmQfR5ekwIhAMOac+yF2HPoHUJHz2P8igZIigyO91r0PSLJNEKMJL1g';
        //-- 3.设置 私钥
        decryptObj.setPrivateKey(keys)  
        //-- 4.解密 
        decryptStr = decryptObj.decrypt(params);
        //返回 加密后的 字符串
        return decryptStr;
    },
    //AES 加密
    encryptionAES: (that,params) => {
        let keys = '' , encryptorStr = '';
        keys = that.$cryptoJS.enc.Utf8.parse("onLineTradeTKAMC");
        params = that.$cryptoJS.enc.Utf8.parse(params);
        // 开始加密
        encryptorStr = that.$cryptoJS.AES.encrypt(
            params, 
            keys, 
            { 
                mode: that.$cryptoJS.mode.ECB, 
                padding: that.$cryptoJS.pad.Pkcs7
            }
        );
        //encryptorStr = encryptorStr.ciphertext.toString().toUpperCase(); //转换密文后 解密失败
        encryptorStr = String(encryptorStr); //之将加密后的转换成 字符串, 解密成功
        //返回 加密后的 字符串
        return encryptorStr;
    },
    //AES 解密
    decryptAES: (that,params) => { 
        let keys = '' , decryptStr = '';
        keys = that.$cryptoJS.enc.Utf8.parse("onLineTradeTKAMC");
        // 开始解密
        decryptStr = that.$cryptoJS.AES.decrypt(
            params, 
            keys, 
            {
                mode: that.$cryptoJS.mode.ECB,
                padding: that.$cryptoJS.pad.Pkcs7
            }
        );
        decryptStr = that.$cryptoJS.enc.Utf8.stringify(decryptStr).toString();
        //返回 解密后的 字符串
        return decryptStr;
    },
     //AES 加密
     encryptionAES_kf: (that,params,key) => {
        let keys = '' , encryptorStr = '';
        keys =  that.$cryptoJS.enc.Utf8.parse(key);
        params = that.$cryptoJS.enc.Utf8.parse(params);
        // 开始加密
        encryptorStr = that.$cryptoJS.AES.encrypt(
            params, 
            keys, 
            { 
                mode: that.$cryptoJS.mode.ECB, 
                padding: that.$cryptoJS.pad.Pkcs7
            }
        );
        //encryptorStr = encryptorStr.ciphertext.toString().toUpperCase(); //转换密文后 解密失败
        encryptorStr = String(encryptorStr); //之将加密后的转换成 字符串, 解密成功
        //返回 加密后的 字符串
        return encryptorStr;
    },
    //AES 解密
    decryptAES_kf: (that,params,key) => { 
        let keys = '' , decryptStr = '';
        keys = that.$cryptoJS.enc.Utf8.parse(key);
        // 开始解密
        decryptStr = that.$cryptoJS.AES.decrypt(
            params, 
            keys, 
            {
                mode: that.$cryptoJS.mode.ECB,
                padding: that.$cryptoJS.pad.Pkcs7
            }
        );
        decryptStr = that.$cryptoJS.enc.Utf8.stringify(decryptStr).toString();
        //返回 解密后的 字符串
        return decryptStr;
    },
    
    //base64加密
    encode64: (input) => {
        var _keyStr ="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";  
        var output = "", chr1, chr2, chr3, enc1, enc2, enc3, enc4, i = 0;
        input = obj._utf8_encode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output +
            _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
    },
	//base64解码
	decode64:(e)=>{      
	    var _keyStr ="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";  
		var t = "";
		var n, r, i;
		var s, o, u, a;
		var f = 0;
		e = e.replace(/[^A-Za-z0-9+/=]/g, "");
		while (f < e.length) {
			s = _keyStr.indexOf(e.charAt(f++));
			o = _keyStr.indexOf(e.charAt(f++));
			u = _keyStr.indexOf(e.charAt(f++));
			a = _keyStr.indexOf(e.charAt(f++));
			n = s << 2 | o >> 4;
			r = (o & 15) << 4 | u >> 2;
			i = (u & 3) << 6 | a;
			t = t + String.fromCharCode(n);
			if (u != 64) {
				t = t + String.fromCharCode(r)
			}
			if (a != 64) {
				t = t + String.fromCharCode(i)
			}
		}
		t = obj._utf8_decode(t);
		return t
	},
	_utf8_encode: function(e) {
		e = e.replace(/rn/g, "n");
		var t = "";
		for (var n = 0; n < e.length; n++) {
			var r = e.charCodeAt(n);
			if (r < 128) {
				t += String.fromCharCode(r)
			} else if (r > 127 && r < 2048) {
				t += String.fromCharCode(r >> 6 | 192);
				t += String.fromCharCode(r & 63 | 128)
			} else {
				t += String.fromCharCode(r >> 12 | 224);
				t += String.fromCharCode(r >> 6 & 63 | 128);
				t += String.fromCharCode(r & 63 | 128)
			}
		}
		return t
	},
	_utf8_decode: function(e) {
		var t = "";
		var n = 0,c2=0,c1=0,c3=0;
		var r = 0;
		while (n < e.length) {
			r = e.charCodeAt(n);
			if (r < 128) {
				t += String.fromCharCode(r);
				n++
			} else if (r > 191 && r < 224) {
				c2 = e.charCodeAt(n + 1);
				t += String.fromCharCode((r & 31) << 6 | c2 & 63);
				n += 2
			} else {
				c2 = e.charCodeAt(n + 1);
				c3 = e.charCodeAt(n + 2);
				t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
				n += 3
			}
		}
		return t
    },
    /**
     * @func 限制文本框输入emoji表情
     **/
    noEmoji(text) {
        if (typeof (text) !== 'string') return text
        return text.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "")
	},
	/**
     * @func 校验是不是纯数字
     **/
    isNumber(num) {
        num = (num + '').replace(',','');
 
		let pattern = new RegExp(/^[0-9]+\.?[0-9]*$/);
		return pattern.test(num)
    },
	/** 
	 * @func 获取当前日期前 num 的日期
	 * */
	getDateNew: function(num) {
		var today = new Date();
		var yesterday_milliseconds = today.getTime() - (num * 1000) * 60 * 60 * 24;
		var yesterday = new Date();

		yesterday.setTime(yesterday_milliseconds);
		yesterday = yesterday.toLocaleDateString().replace(/年|月/g, "/").replace(/日/g, "").split('/');

		var num = 2;
		if(!parseInt(yesterday[1][0])) {
			num = 4
		}
		yesterday[1].length < num ? yesterday[1] = '0' + yesterday[1] : yesterday[1];
		yesterday[2].length < num ? yesterday[2] = '0' + yesterday[2] : yesterday[2];

		return yesterday.join('-');
    },
    /**
     * @func 校验是不是手机号 
     **/
    isMobilPhone: (phone) => {
        //目前只校验 1 开头的 11 位数字
        return /^(1)\d{10}$/.test(phone);
    },
    /**
     * @func 校验密码规则
     */
    isPwdPass: (strPwd) => { 
        // ~!@#$%^&amp;*()_+`\-={}:";'&lt;&gt;?,.
        let pwdReg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%.\/]).{8,16}$/,
            pwdRegNew = /^(?=.*[a-zA-Z])(?=.*\d).{8,16}$/ , isPass = true;
        //判断是不是包含了 数字 字母 和 特殊符号
        if(!pwdReg.test(strPwd)){
            //判断是不是包含了 数字 和 字母
            if(!pwdRegNew.test(strPwd)){
                isPass = false
            }
        } 
        return isPass;
    },
    /**
     * @func 设置 sessionStorage 
     */
    setSession:(s_name,val) => {
        s_name = obj.encryptionAES(vue.prototype,s_name);
        val = obj.encryptionAES(vue.prototype,val);
        // 存到 sessionStorage
        sessionStorage[s_name] = val;
    },
    /**
     * @func 获得 sessionStorage 
     */
    getSession:(s_name) => {
        let val = sessionStorage[obj.encryptionAES(vue.prototype,s_name)];
        if(val){
            return obj.decryptAES(vue.prototype,val);
        }else{
            return '';
        }
    },
    /**
     * @func 删除 sessionStorage 
     */
    delSession:(s_name) => {
        let nameList = s_name.split(',');
        // 遍历 删除 sessionStorage
        nameList.map((val,k) => {
            sessionStorage.removeItem(obj.encryptionAES(vue.prototype,val));
        }); 
    },
    /**
	 * 设置cookie
	 * @param {*} c_name : key
	 * @param {*} value : val
	 */
	setCookie:(c_name,value) => {
        // 先删除cookie
        obj.delCookie(c_name);
        // 开始设置cookie
        var exp = new Date();
        c_name = obj.encryptionAES(vue.prototype,c_name).replace(/=/g,'TK_COOKIE');
        value = obj.encryptionAES(vue.prototype,value);
		//过期时间是 30分钟
		exp.setTime(exp.getTime() + 30*60*1000);
        document.cookie = c_name + "="+ escape (value) + "; expires=" + exp.toGMTString()+"; path=/tkweb-web/fundsFixed";
        document.cookie = c_name + "="+ escape (value) + "; expires=" + exp.toGMTString()+"; path=/fundsFixed";
        document.cookie = c_name + "="+ escape (value) + "; expires=" + exp.toGMTString()+"; path=/tkweb-web/fundPurchases";
        document.cookie = c_name + "="+ escape (value) + "; expires=" + exp.toGMTString()+"; path=/fundPurchases";
        document.cookie = c_name + "="+ escape (value) + "; expires=" + exp.toGMTString()+"; path=/";
	},
	/**
	 * 根据 c_name 获得 cookie 的值
	 * @param {*} c_name : key
	 */
	getCookie:(c_name) => {	
		let aCookie,aCrumb,tmpName = obj.encryptionAES(vue.prototype,c_name).replace(/=/g,'TK_COOKIE');
        aCookie = document.cookie.split("; ");
		for(var i = 0; i < aCookie.length; i++) {
            aCrumb = aCookie[i].split("=");	 
			if(tmpName == aCrumb[0]){
				return obj.decryptAES(vue.prototype,unescape(aCrumb[1]));
			}	
		}
		return null;
	},
	/**
	 * 根据 c_name 删除 cookie 的值
	 * @param {*} c_name : key
	 */
	delCookie:(c_name) => {
        var exp = new Date();
        c_name = obj.encryptionAES(vue.prototype,c_name).replace(/=/g,'TK_COOKIE');
		exp.setTime(exp.getTime() - 1);
		var cval = obj.getCookie(c_name); //获得 cookie 的值
		if(cval!=null){
            document.cookie=keys[i]+"=''; expires="+exp.toGMTString()+"; path=/tkweb-web-pre/fundsFixed";
            document.cookie=keys[i]+"=''; expires="+exp.toGMTString()+"; path=/tkweb-web-pre/fundPurchases";
            document.cookie=keys[i]+"=''; expires="+exp.toGMTString()+"; path=/tkweb-web/fundsFixed";
            document.cookie=keys[i]+"=''; expires="+exp.toGMTString()+"; path=/tkweb-web/fundPurchases";
            document.cookie=keys[i]+"=''; expires="+exp.toGMTString()+"; path=/fundsFixed";
            document.cookie=keys[i]+"=''; expires="+exp.toGMTString()+"; path=/fundPurchases";
            document.cookie=keys[i]+"=''; expires=" + exp.toUTCString() + '; path=/';
		}	
    },
	/**
	 * 跟新cookie
	 * @param {*} c_name : key
	 * @param {*} value : key
	 */
	updataCookie:(c_name,value) => {
		obj.delCookie(c_name); //-- 先删除 cookie
		obj.setCookie(c_name,value); //-- 再更新cookie
	},
}
export default obj;


// WEBPACK FOOTER //
// ./src/tools/common.js